import { InjectionToken } from '@angular/core';
import { IUploadFeedback } from './interfaces/IUploadFeedback';

export const UPLOAD_FEEDBACK_TOKEN = new InjectionToken<IUploadFeedback>('UploadFeedback');
